export default "__VITE_ASSET__CO4ER39W__"